/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Количество связанных записей
 * @export
 * @interface GetRegistry200ResponseDataCounts
 */
export interface GetRegistry200ResponseDataCounts {
  /**
   *
   * @type {number}
   * @memberof GetRegistry200ResponseDataCounts
   */
  applications: number
  /**
   *
   * @type {number}
   * @memberof GetRegistry200ResponseDataCounts
   */
  ips: number
}

/**
 * Check if a given object implements the GetRegistry200ResponseDataCounts interface.
 */
export function instanceOfGetRegistry200ResponseDataCounts(
  value: object
): value is GetRegistry200ResponseDataCounts {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('ips' in value) || value['ips'] === undefined) return false
  return true
}

export function GetRegistry200ResponseDataCountsFromJSON(
  json: any
): GetRegistry200ResponseDataCounts {
  return GetRegistry200ResponseDataCountsFromJSONTyped(json, false)
}

export function GetRegistry200ResponseDataCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistry200ResponseDataCounts {
  if (json == null) {
    return json
  }
  return {
    applications: json['applications'],
    ips: json['ips'],
  }
}

export function GetRegistry200ResponseDataCountsToJSON(
  value?: GetRegistry200ResponseDataCounts | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: value['applications'],
    ips: value['ips'],
  }
}
